// @ts-check

import { List } from "antd";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import { BorderedPanel } from "~/components/Shared/PageParts";
import { dateFormatterNoTime, safeProfilePic } from "~/other/Helper";
import useOrganizationId from "~/hooks/useOrganizationId";
import DefaultPost from "~/components/Bulletin/DefaultPost";

export default function LatestActivityList({ posts }) {
    const orgId = useOrganizationId();

    const latestActivity = useMemo(() => {
        return posts.map((post) => {
            return {
                id: post.post_uuid,
                title: (
                    <Link
                        to={`/${orgId}/home/team/my_teams/feed/post/${post.post_uuid}`}
                        className="link-hover zero-blue"
                    >
                        {post.title}
                    </Link>
                ),
                description: (
                    <>
                        <div className="zero-dark-grey">{post.source_team.name}</div>
                        <div className="zero-dark-grey">{dateFormatterNoTime(post.revised_at)}</div>
                    </>
                ),
                avatar: safeProfilePic(post.revised_by, "img-sm img-circle bulletin", "bulletin"),
            };
        });
    }, [posts]);

    return (
        <BorderedPanel style={{ height: "550px", overflow: "hidden", marginBottom: "1rem", padding: "1rem 0 0 2rem" }}>
            <h4
                className="zero-blue pad-y-10"
                style={{ height: "40px", margin: 0, borderBottom: "1px solid rgba(5, 5, 5, 0.06)" }}
            >
                Latest Activity 📣
            </h4>
            {latestActivity.length === 0 ? (
                <div style={{ margin: "1rem 2rem 0 0" }}>
                    <DefaultPost teamSpecific={false} />
                </div>
            ) : (
                <div style={{ height: "500px", overflow: "auto" }}>
                    <List
                        itemLayout="horizontal"
                        className="ant-list-vcenter-icons"
                        dataSource={latestActivity}
                        renderItem={(item) => (
                            <List.Item key={item.id} id={item.id}>
                                <List.Item.Meta
                                    avatar={item.avatar}
                                    title={item.title}
                                    description={item.description}
                                />
                            </List.Item>
                        )}
                    />
                </div>
            )}
        </BorderedPanel>
    );
}
